import api from '.';
import { AccountRole } from '@karehero/models';

export const accountRoleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllAccountRole: builder.query<AccountRole[], void>({
      query: () => '/account-role',
      providesTags: ['AccountRoles'],
    }),
  }),
});

export const { useGetAllAccountRoleQuery } = accountRoleApi;

export default accountRoleApi;
